import { z } from 'zod';
/**
 * Supported AI visualization chart types
 */
// TODO: Think better naming for this or sharing similar names with explorer
export var AiChartType;
(function (AiChartType) {
    AiChartType["TIME_SERIES_CHART"] = "time_series_chart";
    AiChartType["VERTICAL_BAR_CHART"] = "vertical_bar_chart";
    AiChartType["CSV"] = "csv";
})(AiChartType || (AiChartType = {}));
export const baseAgentSchema = z.object({
    uuid: z.string(),
    projectUuid: z.string(),
    organizationUuid: z.string(),
    name: z.string(),
    description: z.string(),
    imageUrl: z.string().url().nullable(),
    tags: z.array(z.string()).nullable(),
    integrations: z.array(
    // z.union([
    // TODO: once we add more integrations, we should use union
    z.object({
        type: z.literal('slack'),
        channelId: z.string(),
    })),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    instruction: z
        .string()
        .max(4096, 'Custom instruction is too long. Maximum allowed is 4,000 characters.')
        .nullable(),
    provider: z.string(),
    model: z.string(),
});
export * from './filterExploreByTags';
//# sourceMappingURL=index.js.map